import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  GetMarketingContactsParams,
  GetMarketingContactsResponse
} from "../../marketing.types";

export const requestGetMarketingContacts = async (
  params: GetMarketingContactsParams
): Promise<GetMarketingContactsResponse> => {
  return await instance.get(ApiRoutesMarketing.Contacts, { params });
};
